export const team = [
  {
    name: 'Ricky Regalado',
    // description: `The Front Man. The Leader. The Visionary.`,
    icon: 'fab fa-linkedin-in',
    position: 'CEO',
    socialProfile: 'https://www.linkedin.com/in/rickyregalado/'
  },
  // {
  //   name: 'Joe Grotto',
  //   // description: `CoFounder, Technology and Marketing Nerd.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'CPO',
  //   socialProfile: 'https://www.linkedin.com/in/joegrotto/'
  // },
  // {
  //   name: 'Tesh Shah',
  // description: `CoFounder, UI Ninja and Lead Engineer.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'CTO',
  //   socialProfile: 'https://www.linkedin.com/in/theprotagony/'
  // },
  // {
  //   name: 'Ezra Cook',
  //   // description: `Math and Data Science Wizard. He's a Doctor.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'Data Scientist',
  //   socialProfile: 'https://www.linkedin.com/in/ezrajcook/'
  // },
  // {
  //   name: 'Greg Berg',
  //   // description: `A Support Superstar. The Social Butterfly at Route.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'Customer Success',
  //   socialProfile: 'https://www.linkedin.com/in/gregory-berg-bb206530/'
  // },
  {
    name: 'Ricky Funk',
    // description: `The Family Man. The Wise Guy. The Go Getter.`,
    icon: 'fab fa-linkedin-in',
    position: 'Chief Technology Officer',
    socialProfile: 'https://www.linkedin.com/in/ricardofunk/'
  },
  {
    name: 'Victor Fuentes',
    // description: `The Family Man. The Wise Guy. The Go Getter.`,
    icon: 'fab fa-linkedin-in',
    position: 'Full Stack Engineer',
    socialProfile: 'https://www.linkedin.com/in/victor-fuentes-dev/'
  },
  // {
  //   name: 'Armando Bello',
  //   // description: `The Data Minded Sales Guy We All Need.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'Business Development',
  //   socialProfile: 'https://www.linkedin.com/in/armando-bello3/'
  // },
  {
    name: 'Domenico Amoroso',
  // description: `The Biggest Man on Earth. Personality to Match.`,
    icon: 'fab fa-linkedin-in',
    position: 'Support Specialist',
    socialProfile: 'https://www.linkedin.com/in/domenico-amoroso-7abb8215b/'
  },
  {
    name: 'Dominic Amoroso',
  // description: `The Biggest Man on Earth. Personality to Match.`,
    icon: 'fab fa-linkedin-in',
    position: 'Customer Success',
    socialProfile: 'https://www.linkedin.com/in/dominic-amoroso-48577744/'
  },
  // {
  //   name: 'Sal Ortiz',
  //   // description: `The infrastructure is the best part! But it’s a face only a mother can love.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'Backend Engineer',
  //   socialProfile: 'https://www.linkedin.com/in/salvador-ortiz-jr/'
  // },
  // {
  //   name: 'Stephen Sotor',
  //   // description: `The Showman. The Content Creator.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'Digital Media',
  //   socialProfile: 'https://www.linkedin.com/in/stephen-sotor-5bb25853/'
  // }
  // {
  //   name: 'Emma Steiber',
  //   // description: `The Queen. The Researcher. The Designer.`,
  //   icon: 'fab fa-linkedin-in',
  //   position: 'UI/UX Designer',
  //   socialProfile: 'https://www.linkedin.com/in/emma-steiber/'
  // }
]
